<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" :class="{active: !item.path}" :key="index" v-for="(item, index) in items">
                <router-link :to="item.path" v-if="item.path">{{item.label}}</router-link>
                <span v-else>{{item.label}}</span>
            </li>
        </ol>
    </nav>
</template>

<script>
    export default {
        name: "Breadcrumb",
        props: {
            items: {
                type: Array,
                required: true,
                validator: v => {
                    return v.length !== 0 && v.filter(value => !value.label).length === 0;
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../../assets/css/variables";
    .breadcrumb {
        display: flex;
        flex-wrap: wrap;
        padding: 10px;
        list-style: none;
        width: auto;
        margin-bottom: 0;
        font-size: .9em;

    }

    .breadcrumb-item {
        a {
            color: $theme_color_three;
        }

        + .breadcrumb-item {
            padding-left: 0.5rem;

            &::before {
                display: inline-block;
                padding-right: 0.5rem;
                color: $theme_color_three;
                content: ">";
            }

            &:hover::before {
                text-decoration: none;
            }
        }

        &.active {
            color: #fff;
        }
    }

    @media only screen and (max-width: 576px) {
        .breadcrumb {
            display: none;
        }
    }
</style>
